<template>
  <div class="row box-col">
    <div class="col-sm-0 col-md-3">

    </div>
    <div class="col-sm-12 col-md-9 px-2" >
      <div class="btn-control btn-previous" @click="previous(id)">
        <i class="fas fa-chevron-left"></i>
      </div>
      <div style="padding: 0 15px">
        <div v-if="products && products.length > 0">
          <div class="subImage" :id="id"> 
            <span v-for="(product , index) in products" :key="index">
              <div class="box-product-item">
                <div class="item" style="height:300px">
                  <div style="padding: 10px;">
                    <a :href="`/productDetail/${product.id}`">
                      <img :src="product.get('images')[0]._url">
                      <p class="name ">{{product.get('name')}}</p>
                      <p class="price" v-if="product.get('price')">
                        <small style="text-decoration: line-through;font-size:13px;color: #858585;">฿{{eArabic(product.get('fullPrice') )}}</small>
                        ฿{{eArabic(product.get('price'))}}<small style="font-size:13px;color: #858585;">/{{product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</small>
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div class="btn-control btn-next" @click="next(id)">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props:['category' , 'type' , 'id'],
  data(){
    return{
      page:0,
      products: ""
    }
  },
  async mounted(){
    this.products = _.sortBy(this.allProduct , (p) =>{
      return p.viewerCounter
    }).reverse();
    if(this.type){
      if(type == 'new'){
        this.products = this.products.filter(d => { return d.get('isNew') })
      }else if(type == 'promotion'){
        this.products = this.products.filter(d => { return d.get("fullPrice") && d.get("fullPrice") > d.get("price") })
      }
    }
    if(this.category){
      this.products = this.products.filter(d => { return d.get('category') == this.category})  
    }
  },
  methods:{
    eArabic(x, num = 0) {
      if (x)
        return x.toLocaleString(undefined, {
          minimumFractionDigits: num,
          maximumFractionDigits: num
        });
      else return num == 2 ? "0.00" : "0";
    },
    next(id){
      document.getElementById(id).scrollLeft += 300
    },
    previous(id){
      document.getElementById(id).scrollLeft -= 300
    }
  },
  computed: {
    ...mapState([
      'allProduct',
    ])
  },
}
</script>
<style scoped lang='scss'>
*{
  
}
a{
  color: black;
  text-decoration: none;
}
img{
  width: 100%;
  height: auto;
}
.subImage{
  cursor: pointer;
  overflow-x: scroll;
  white-space: nowrap;
  position: relative;
  width: 100%;
  box-shadow: inset 0 -7px 9px -7px rgba(0,0,0,0.4);
  padding: 10px 10px;
  scroll-behavior: smooth;
}
.name{
  display: block;
  white-space: normal;
  min-height: 48px;
  text-align: center;
}
.box-product-item{
  padding: 15px;
  width: 250px;
  display: inline-block;
  vertical-align: top;
  transition: all 200ms;
  font-size: 14px;
  color: black;
}
.box-product-item .item {
  border: 1px solid rgba(148, 148, 148, 0.5);
  border-radius: 15px;

}
.box-product-item p {
  padding: 0;
  margin: 0;
}
.box-product-item .item .price{
  color: #e9773b;
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 0;
}
.box-product-item:hover {
  opacity: .8;
  transform: scale(1.01);
  
}
.box-product-item:hover .item{
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
}
.btn-control{
  height: calc(100% - 20px);
  background-color: rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.5);
  width: 35px;
  position:absolute;
  z-index: 15;
  cursor: pointer;
  transition: all 200ms;
  border-radius: 5px;
  i{
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 25px;
    transform: translate(-50% , -50%);
  }
}
.btn-control:hover{
  background-color: rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.6);
}
.btn-next{
  right: 0;
  top: 0;
}
</style>